import * as z from "zod/v4";

export const getOutreachUnsubscribes = {
  name: "getOutreachUnsubscribes" as const,
  input: z.object({ campaignId: z.string() }),
  output: z.object({ unsubscribes: z.number() }),
};
